import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { MecordColors } from "Constants/Color";
import { fetchCompanyByDropDown } from "slices/Masters/company/thunk";
import AddressFormModal from "pages/Enquiry/Components/AddressFormModal";

interface AddShippingAddressModalProps {
  show: boolean;
  onHide: () => void;
  companyId: string | null | undefined;
  formikValues: any;
  setFieldValue: (field: string, value: any) => void;
  onAddressAdded?: (newAddress: any) => void;
}

const AddShippingAddressModal: React.FC<AddShippingAddressModalProps> = ({
  show,
  onHide,
  companyId,
  formikValues,
  setFieldValue,
  onAddressAdded,
}) => {
  const dispatch = useDispatch<any>();

  const handleSuccess = async (response: any) => {
    try {
      // Refresh company data to get updated shipping addresses
      const companiesResult = await dispatch(fetchCompanyByDropDown()).unwrap();

      // Find the updated company in the fetched data
      const updatedCompany = companiesResult.data?.find(
        (c: any) => c.company_id === companyId || c.id === companyId
      );

      if (updatedCompany) {
        // Update company in formik with new shipping addresses
        setFieldValue("company", {
          ...formikValues.company,
          shipping_addresses: updatedCompany.shipping_addresses || [],
        });

        // Call the callback with the new address if provided
        const newAddress =
          response?.data?.createdAddress || response?.createdAddress;
        if (newAddress && onAddressAdded) {
          onAddressAdded(newAddress);
        }
      }

      onHide();
    } catch (error) {
      console.error("Error refreshing company data:", error);
      onHide();
    }
  };

  return (
    <>
      <style>
        {`
          /* Make React-Bootstrap white close button fully bright */
          .bright-white-close .btn-close {
            filter: invert(1) brightness(2);
            opacity: 1;
          }
          .bright-white-close .btn-close:hover {
            filter: invert(1) brightness(2.5);
          }
        `}
      </style>
      <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        size="xl"
        centered
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          style={{
            backgroundColor: MecordColors?.ThemeBGColor,
            paddingBottom: "20px",
          }}
          className="bright-white-close"
        >
          <Modal.Title style={{ color: "#fff" }}>
            Add New Shipping Address
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
          {companyId ? (
            <AddressFormModal
              company_id={companyId}
              formik={{ values: formikValues, setFieldValue } as any}
              onSuccess={handleSuccess}
              onCancel={onHide}
            />
          ) : (
            <div className="text-center py-5">
              <div className="mb-4">
                <i
                  className="bi bi-exclamation-circle"
                  style={{ fontSize: "3rem", color: MecordColors.ThemeBGColor }}
                ></i>
              </div>
              <h5 className="mb-3" style={{ color: MecordColors.NormalText }}>
                Customer Selection Required
              </h5>
              <p className="text-muted mb-4" style={{ fontSize: "1rem" }}>
                Please select a customer first before adding a shipping address.
              </p>
              <p className="text-muted mb-4" style={{ fontSize: "0.9rem" }}>
                Go to the <strong>Customer Details</strong> section and select a
                customer to continue.
              </p>
              <Button
                variant="primary"
                onClick={onHide}
                style={{
                  backgroundColor: MecordColors.ThemeBGColor,
                  borderColor: MecordColors.ThemeBGColor,
                }}
              >
                Close
              </Button>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddShippingAddressModal;
